import React from "react";

import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import RouteCardComponent from "./RouteCardComponent";
import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateText,
  EmptyStateTitle,
  RoutesGrid,
} from "./routeOptimizationStyles";

function RoutesList({ routes, isLoading, organizationId, selectedDate }) {
  if (isLoading) {
    return <ComponentCircleLoader />;
  }

  if (!routes || routes.length === 0) {
    return (
      <EmptyState>
        <EmptyStateIcon>🗺️</EmptyStateIcon>
        <EmptyStateTitle>No Routes Found</EmptyStateTitle>
        <EmptyStateText>
          No optimized routes exist for the selected date. Click "Optimize
          Routes" to create routes for your team.
        </EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <RoutesGrid>
      {routes.map(route => (
        <RouteCardComponent
          key={route.id}
          route={route}
          organizationId={organizationId}
          selectedDate={selectedDate}
        />
      ))}
    </RoutesGrid>
  );
}

export default RoutesList;
